<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
            :default-active="$route.path"
            :unique-opened="false"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :active-text-color="variables.menuActiveText"
            collapse-transition
            collapse
            mode="vertical"
            @select="selectMenu">
            <sidebar-item v-for="(router, index) in sideBarList" :key="index" :item="router" :base-path="router.path"/>
        </el-menu>
    </el-scrollbar>
</template>

<script>
import SidebarItem from './SidebarItem';
import variables from '@/style/variables.scss';

export default {
  components: { SidebarItem },
  props: {
    sideBarList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    variables() {
      return variables;
    },
  },
  methods: {
    selectMenu(index, indexPath) {
      this.$emit('select', index, indexPath)
    }
  }
};
</script>
